import React from 'react';
import styled from '@2pulse/responsive';
import { normalize } from '@app/helpers';

const FieldContainer = styled.View({
  marginBottom: normalize(20),
});

const Label = styled.Text(({ theme }) => ({
  fontSize: normalize(18),
  fontWeight: '600',
  color: theme.colors.babypowder,
  marginBottom: normalize(12),
  letterSpacing: 0.5,
  lineHeight: normalize(24),
}));

export const HelperText = styled.Text(({ theme }) => ({
  color: theme.colors.babypowder,
  fontSize: normalize(14),
  fontWeight: '400',
  marginTop: normalize(8),
  opacity: 0.7,
  fontStyle: 'italic',
}));

interface FieldWithLabelProps {
  label: string;
  children: React.ReactNode;
}

export const FieldWithLabel = ({ label, children }: FieldWithLabelProps) => {
  return (
    <FieldContainer>
      <Label>{label}</Label>
      {children}
    </FieldContainer>
  );
};